import React from "react";
import { SPAStickyFooter } from './SPAStickyFooter';
import { ModalLinkButton } from '../Controls/Button/ModalLinkButton';
import { PrivacyPolicy } from '../assets/Documents/PrivacyPolicy';
import { TermsAndConditions } from '../assets/Documents/TermsAndConditions';
import { CookiePolicy } from '../assets/Documents/CookiePolicy';
import { Attributions } from '../assets/Documents/Attributions';
import { ContactUs } from '../assets/Documents/ContactUs';
import { Accreditation } from '../assets/Documents/Accreditation';
import { PartnershipOpportunities } from '../assets/Documents/PartnershipOpportunities';
import { HelpCentre } from '../assets/Documents/HelpCentre';
import { StatusPage } from '../assets/Documents/StatusPage';
import { ReportIssue } from '../assets/Documents/ReportIssue';
import { AboutPage } from '../assets/Documents/AboutPage';
import { HowSkitterbookWorks } from '../assets/Documents/HowSkitterbookWorks';
import { CompanyInformation } from '../assets/Documents/CompanyInformation';
import "./css/SPAFooter.css";

interface SPAFooterProps {
    onSkickyFooterVisibilityChange?: (value: boolean) => void;
}

export const SPAFooter: React.FC<SPAFooterProps> = ({ onSkickyFooterVisibilityChange }) => {

    const versionString = "1.0.3.39";

    return (
        <>           
            <footer id="main-footer" className="spa-footer">
                <div className="spa-footer__section">
                    <h4 className="spa-footer__heading">Accreditation & Essentials</h4>
                    <ul>
                        <li><ModalLinkButton Title="Accreditation" modalTitle="Accreditation"><Accreditation version={versionString} /></ModalLinkButton></li>
                        <li><ModalLinkButton Title="Contact Us" modalTitle="Contact Us"><ContactUs /></ModalLinkButton></li>
                    </ul>
                </div>

                <div className="spa-footer__section">
                    <h4 className="spa-footer__heading">Legal</h4>
                    <ul>
                        <li><ModalLinkButton Title="Privacy Policy" modalTitle="Privacy Policy"><PrivacyPolicy /></ModalLinkButton></li>
                        <li><ModalLinkButton Title="Terms and Conditions" modalTitle="Terms and Conditions"><TermsAndConditions /></ModalLinkButton></li>
                        <li><ModalLinkButton Title="Cookie Policy" modalTitle="Cookie Policy"><CookiePolicy /></ModalLinkButton></li>
                        <li><ModalLinkButton Title="Licensing & Attributions" modalTitle="Licensing & Attributions"><Attributions /></ModalLinkButton></li>
                    </ul>
                </div>

                <div className="spa-footer__section">
                    <h4 className="spa-footer__heading">Operational & Support</h4>
                    <ul>
                        <li><ModalLinkButton Title="Help Centre" modalTitle="Help Centre"><HelpCentre /></ModalLinkButton></li>
                        <li><ModalLinkButton Title="Status Page" modalTitle="Status Page"><StatusPage /></ModalLinkButton></li>
                        <li><ModalLinkButton Title="Report Issue" modalTitle="Report An Issue"><ReportIssue /></ModalLinkButton></li>
                        <li><ModalLinkButton Title="Partnership Opportunities" modalTitle="Partnership Opportunities"><PartnershipOpportunities /></ModalLinkButton></li>
                    </ul>
                </div>

                <div className="spa-footer__section">
                    <h4 className="spa-footer__heading">Product & Navigation</h4>
                    <ul>
                        <li><ModalLinkButton Title="About Skitterbook" modalTitle="About Skitterbook"><AboutPage version={versionString} /></ModalLinkButton></li>
                        <li><ModalLinkButton Title="How Skitterbook Works" modalTitle="How Skitterbook Works"><HowSkitterbookWorks /></ModalLinkButton></li>
                    </ul>
                </div>

                <div className="spa-footer__section">
                    <h4 className="spa-footer__heading">Company Information</h4>
                    <ul>
                        <li><ModalLinkButton Title="Company Registration Details" modalTitle="Company Registration Details"><CompanyInformation /></ModalLinkButton></li>
                        <li>© Skitterbook — All Rights Reserved</li>
                    </ul>
                </div>
            </footer>
        </>
    );
};
